/**
 * @author HungNS
 */
const getRootDomain = () => {
    return process.env.VUE_APP_ROOT_DOMAIN;
};

const getDomain = () => {
    return process.env.VUE_APP_API_DOMAIN
};

const isUatEnvironment = () => {
     return process.env.NODE_ENV === 'production';
};

const getLogoutEndPoint = () => {
    return process.env.VUE_APP_LOGOUT_ENDPOINT
}

const getSupportFAQUrl = () => {
    return process.env.VUE_APP_SUPPORT_FAQ
}

const getSupportSecurityUrl = () => {
    return process.env.VUE_APP_SUPPORT_SECURITY
}

const getWithdrawalHelpUrl = () => {
    return process.env.VUE_APP_WITHDRAWAL_HELP
}

const getDepositHelpUrl = () => {
    return process.env.VUE_APP_DEPOSIT_HELP
}

const getMyHelpUrl = () => {
    return process.env.VUE_APP_MY_HELP
}

const getReportHelpUrl = () => {
    return process.env.VUE_APP_REPORT_HELP
}

const getReportSupportLink = () => {
    return process.env.VUE_APP_REPORT_SUPPORT
}

const getDeepLinkCloseFXIOS = function () {
    return process.env.VUE_APP_DEEP_LINK_CLOSE_FX_IOS
}

const getDeepLinkCloseFXAndroid = function () {
    return process.env.VUE_APP_DEEP_LINK_CLOSE_FX_ANDROID
}

const getRegisterPasskeySupportLink = function () {
    return process.env.VUE_APP_REGISTER_PASSKEY_SUPPORT_LINK
}

const getRegisterPasskeySecurityLink = function () {
    return process.env.VUE_APP_REGISTER_PASSKEY_SECURITY_LINK
}

export default {
    getDomain,
    isUatEnvironment,
    getLogoutEndPoint,
    getRootDomain,
    getSupportFAQUrl,
    getSupportSecurityUrl,
    getWithdrawalHelpUrl,
    getDepositHelpUrl,
    getMyHelpUrl,
    getReportHelpUrl,
    getReportSupportLink,
    getDeepLinkCloseFXIOS,
    getDeepLinkCloseFXAndroid,
    getRegisterPasskeySupportLink,
    getRegisterPasskeySecurityLink
}
